import script from "./ClassHealthOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassHealthOverview.vue?vue&type=script&setup=true&lang=js"

import "./ClassHealthOverview.vue?vue&type=style&index=0&id=4c96a589&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c96a589"]])

export default __exports__